import { lazy, useState, Suspense, useEffect } from 'react';

import { useCreditPurchase } from 'src/sections/settings/billing/context/CreditPurchaseContext';

// ----------------------------------------------------------------------

// Mounted on every page but hidden until opened, so its code loads on first open instead of in the
// entry chunk. Once loaded it stays mounted so its close transition still plays.

const CreditPurchaseModal = lazy(() =>
  import('src/sections/settings/billing/components/CreditPurchaseModal').then((m) => ({
    default: m.CreditPurchaseModal,
  }))
);

function useOpenedOnce(isOpen: boolean) {
  const [opened, setOpened] = useState(isOpen);

  useEffect(() => {
    if (isOpen) setOpened(true);
  }, [isOpen]);

  return opened || isOpen;
}

export function LazyCreditPurchaseModal() {
  const { isOpen } = useCreditPurchase();

  const opened = useOpenedOnce(isOpen);

  if (!opened) return null;

  return (
    <Suspense fallback={null}>
      <CreditPurchaseModal />
    </Suspense>
  );
}
